import { Component, DestroyRef, ElementRef, EventEmitter, inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalFunctions, SnackType } from '@global/GlobalFunctions';
import { siteSubscriptions } from '@services/siteSubscriptions';
import { IOrganisationsHierarchy, OrganisationDataService, OrganisationsHierarchy } from '@services/organisation-data.service';
import {
	ContextMenuComponent, DragAndDropEventArgs, MenuEventArgs, MenuItemModel, NodeClickEventArgs,
	NodeExpandEventArgs, NodeSelectEventArgs, TreeViewComponent
} from '@syncfusion/ej2-angular-navigations';
import { BehaviorSubject, combineLatest, distinctUntilChanged, filter, finalize, firstValueFrom, Observable, Subject, takeUntil } from 'rxjs';
import { AssetsDataService, LevelAsset } from '@services/assets-data.service';
import { AuthenticationService, IWebAppUser } from '@services/authentication.service';

import { RulesDataService } from '@services/rules-data.service';
import { TreeDashboardDrag } from '../organisation-data-model/organisation-data-model.component';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

/**
 * Component
 */
@Component({
	selector: 'app-hierarchy-management',
	templateUrl: './hierarchy-management.component.html',
	styleUrls: ['./hierarchy-management.component.scss', 'icons.component.css']
})
export class HierarchyManagementComponent implements OnInit {

	/** Show the Spinner */
	public showSpinner: boolean = false

	/** Observable Subject Finalise */
	private destroyRef = inject(DestroyRef);

	/** hierarchical Data */
	private hierarchicalData$: Observable<any>;
	/** hierarchical Data Subject*/
	private hierarchicalDataSubject: BehaviorSubject<any>;

	/** hierarchicalData */
	public hierarchicalData: OrganisationsHierarchy[];
	/** treeData */
	public treeData: OrganisationsHierarchy[];
	/** ShowHiddenLocations */
	public ShowHiddenLocations: number = 1;
	/** nodeState */
	private nodeState: any = []
	/** field */
	public fields: Object

	/** locationID */
	public locationID: string;
	/** locationType */
	public locationType: string = "location"


	/** Allow multi selection */
	public allowMultiSelection: boolean = true;
	/** Allow drag and drop */
	public allowDragAndDrop: boolean = true;

	/** accountID */
	public accountID: string;

	/** OrganisationID */
	public OrganisationID: string;

	/** this user */
	public thisUser: IWebAppUser;

	/** menuItems */
	public menuItems: MenuItemModel[] = [
		{
			text: 'Add Asset',
			// iconCss: 'e-cm-icons e-cut'
		},
		{
			text: 'Copy Asset',
			// iconCss: 'e-cm-icons e-copy'
		},
		{
			separator: true
		},
		{
			text: 'Delete Asset',
			// iconCss: 'e-cm-icons e-copy'
		}

	]

	/** isLoading */
	public isLoading = true; //for tree spinner

	/** contextMenu */
	@ViewChild('contextmenu') public contextMenu: ContextMenuComponent;

	/** treeView */
	@ViewChild('treeView', { static: true }) public treeView: TreeViewComponent;

	/** treeContainer */
	@ViewChild('treeContainer', { static: false }) public treeContainer: ElementRef;

	/** content */
	public content: string = 'click me';
	/** savedScrollPosition */
	private savedScrollPosition: number = 0;
	/** checkedAssetIDs */
	public checkedAssetIDs: number[] = [];
	/** assetIDsWithActiveRules */
	public assetIDsWithActiveRules: number[] = [];
	/** assets */
	public assets: LevelAsset[];

	/** selectedLocationUID */
	public selectedLocationUID: string;

	/** onDashboardCreationPage */
	@Input() onDashboardCreationPage: boolean = false;

	/** flattenedSubLocations */
	public flattenedSubLocations: OrganisationsHierarchy[];

	/** dragComplete */
	@Output() dragComplete = new EventEmitter<TreeDashboardDrag>();

	/**
	 *
	 * @param siteSubscriptions  siteSubscriptions
	 * @param globalFunctions globalFunctions
	 * @param router router
	 * @param route route
	 * @param assetsDataService assetsDataService
	 * @param organisationDataService organisationDataService
	 * @param authenticationService authenticationService
	 * @param rulesDataService RulesDataService
	 */
	constructor(
		private siteSubscriptions: siteSubscriptions,
		private globalFunctions: GlobalFunctions,
		private router: Router,
		private route: ActivatedRoute,
		private assetsDataService: AssetsDataService,
		private organisationDataService: OrganisationDataService,
		private authenticationService: AuthenticationService,
		private rulesDataService: RulesDataService) {

		this.hierarchicalDataSubject = new BehaviorSubject<any>([]);
		this.hierarchicalData$ = this.hierarchicalDataSubject.asObservable();

		this.nodeState = [];
		let HeirarchyExpandedNodes = localStorage.getItem("HeirarchyExpandedNodes")
		if (HeirarchyExpandedNodes) { this.nodeState = JSON.parse(HeirarchyExpandedNodes) }

		combineLatest([
			this.authenticationService.currentUser$,
			this.siteSubscriptions.myOrganisations$,
			this.route.paramMap.pipe(distinctUntilChanged()),
			this.route.queryParamMap.pipe(distinctUntilChanged())
		]).pipe(
			// Ensure that subscriptions are not null or undefined
			filter(([currentUser, myOrganisations, paramMap, queryParamMap]) =>
				!!currentUser && !!myOrganisations && !!paramMap && !!queryParamMap),
			takeUntilDestroyed(this.destroyRef)
		).subscribe({
			next: ([currentUser, myOrganisations, paramMap, queryParamMap]) => {

				this.thisUser = <IWebAppUser>currentUser
				var OrganisationID = paramMap.get('organisation') ?? "";

				this.OrganisationID = OrganisationID;

				let Org = myOrganisations.find(o => o.Uid.toLocaleLowerCase() == OrganisationID.toLocaleLowerCase())

				if (Org) {
					this.accountID = Org.AccountGUID!
				}

				if (!this.OrganisationID || !this.accountID) {
					alert("Invalid Access to this Page");
					router.navigate(["."])
				} else {
					//this.getAllAssets()
					this.getOrganisationStructure(this.accountID, this.OrganisationID, this.ShowHiddenLocations);

					this.locationID = queryParamMap.get('locationID') ?? queryParamMap.get('assetID') ?? "";
					if (!this.isParsableAsNumber(this.locationID)) {
						this.locationType = 'location'
					} else { this.locationType = 'asset' }
					this.selectedLocationUID = queryParamMap.get("selectedLocation") ?? "";
					if (this.selectedLocationUID) {
						this.findSelectedLocation(this.selectedLocationUID);
					}
				}

			},
			error: (error) => {
				this.globalFunctions.HandleError(error, "Error: Error in one of the combined subscriptions", false);
			}
		});

		/** Subscribe tp the Tree Structure */
		this.subscribeHierarchicalData()

	}

	/**
	 * getAllAssets
	 */
	async getAllAssets() {

		try {
			const assets = await firstValueFrom(
				this.assetsDataService.getOrganisationAssets$(this.accountID, this.OrganisationID)
			);

			if (assets) {
				this.assets = assets;
				await this.checkActiveRules();
			}
		}
		catch (error: any) {
			this.assets = [];
			if (error.status == 404) { }
			else { this.globalFunctions.HandleError(error, "Error: AssetsDataService.getOrganisationAssets$", false); }
		}

	}

	/**
	 * checkActiveRules
	 */
	async checkActiveRules() {
		this.assetIDsWithActiveRules = [];

		const results = await Promise.all(
			this.assets.map(async asset => {
				try {
					const rules = await firstValueFrom(
						this.rulesDataService.getRules$(
							this.accountID,
							this.OrganisationID,
							asset.AssetID
						)
					);

					return rules.some((rule: any) => rule.Active)
						? asset.AssetID
						: null;
				}
				catch (error) {
					console.log(error);
					return null;
				}
			})
		);

		this.assetIDsWithActiveRules = results.filter(
			(assetID): assetID is number => assetID !== null
		);
	}

	/**
	 * Update the tree if one of the children edits something
	 * @param event
	 */
	async handleDataChanged(event: boolean) {

		if (this.treeContainer) {
			this.savedScrollPosition = this.treeContainer.nativeElement.scrollTop;
		}

		await this.getOrganisationStructure(this.accountID, this.OrganisationID, this.ShowHiddenLocations);

		if (this.treeContainer) {
			setTimeout(() => {
				this.treeContainer.nativeElement.scrollTop = this.savedScrollPosition;
			}, 100);
		}
	}

	/**
	 * getHierarchicalData
	 * @param paramAsset
	 */
	public subscribeHierarchicalData() {
		this.hierarchicalData$.pipe(
			distinctUntilChanged(),
			filter((data) => !!data),
			takeUntilDestroyed(this.destroyRef)
		).subscribe({
			next: (data: any) => {
				if (data && data.length > 0) {
					this.hierarchicalData = data
					this.treeData = data
					this.updateTree();
				}
			},
			error: (error) => { this.globalFunctions.HandleError(error, "Error: this.siteSubscriptions.hierarchicalData$", false) },
		});
	}


	/**
	 * Update Tree
	 */
	updateTree() {
		this.treeData = this.addListItemsAsChildren(this.treeData);
		this.treeData = this.resetExpanded(this.treeData);

		this.flattenedSubLocations = this.flattenSubLocations(this.treeData, true);

		this.fields = {
			dataSource: this.treeData,
			id: 'Uid',
			text: 'concatenatedText',
			child: 'SubChild',
			// iconCss: 'LocationType',
			// imageUrl: 'ImageURL',
			expanded: 'Expanded',
			hidden: 'Hidden',
			parentUID: 'ParentUid'
		};
	}


	/**
	 * Set the expanded state of the nodes according to the stored data
	 * @param data
	 * @returns
	 */
	resetExpanded(data: OrganisationsHierarchy[]): OrganisationsHierarchy[] {

		/**
		 * Internal Function
		 * @param data
		 */
		const transformListItems = (data: any[]) => {
			for (let i = 0; i < data.length; i++) {
				try {
					let node = this.nodeState.find((x: { node: string; }) => x.node.toString().toUpperCase() === data[i].Uid.toString().toUpperCase())
					if (node) {
						if (!data[i].SubChild && !data[i].Assets) {
							data[i].Expanded = false
						} else {
							data[i].Expanded = node["expanded"]
						}
					} else {
						data[i].Expanded = false
					}
					if (data[i].SubChild) {
						transformListItems(data[i].SubChild);
					}
				} catch (error) {
					console.error(error);
				}

			}
		};

		transformListItems(data);

		return data;
	}

	/**
	 * Remember the expanded state of the Nodes in the tree
	 * @param args
	 */
	nodeExpanded(args: NodeExpandEventArgs) {

		if (this.treeContainer) {
			this.savedScrollPosition = this.treeContainer.nativeElement.scrollTop;
		}

		let node = this.nodeState.find((x: { node: string; }) => x.node == args.nodeData["id"]);
		if (node) {
			node["expanded"] = args.nodeData["expanded"];
		} else {
			this.nodeState.push({ "node": args.nodeData["id"], "expanded": args.nodeData["expanded"] });
		}

		localStorage.setItem("HeirarchyExpandedNodes", JSON.stringify(this.nodeState));
		this.updateTree();
		// this.subscribeHierarchicalData();

		if (this.treeContainer) {
			setTimeout(() => { this.treeContainer.nativeElement.scrollTop = this.savedScrollPosition; }, 1);
		}

	}

	/**
	 * addListItemsAsChildren
	 * @param data
	 * @returns
	 */
	addListItemsAsChildren(data: OrganisationsHierarchy[]): OrganisationsHierarchy[] {

		/**
		 * Internal Function
		 * @param data
		 */
		const transformListItems = (data: any[]) => {
			for (let i = 0; i < data.length; i++) {

				if (data[i].concatenatedText == undefined) {
					let _Name = data[i].Name;
					let _FunctionalLocation = data[i].FunctionalLocation;
					if (!!_FunctionalLocation) { _Name = `${_Name} (${_FunctionalLocation})`; }
					data[i].concatenatedText = _Name;
				}

				if (data[i].Assets) {
					data[i].SubChild = data[i].SubChild || [];
					data[i].Assets.forEach((item: any) => {
						if (!item.Deleted) {
							let _Name = item["Name"];
							let _Description = item["Description"];
							if (_Name != _Description && !!_Description) { _Name = `${_Name} - ${_Description}`; }
							item["concatenatedText"] = _Name;
							item["Uid"] = <string>item["AssetID"];
							item["LocationType"] = 'e-icons e-folder';
							data[i].SubChild.push(item);
						}
					});
					data[i].Assets = []; // Clear items after moving them to SubChild
				}
				if (data[i].SubChild) {
					transformListItems(data[i].SubChild);
				}
			}
		};

		transformListItems(data);

		return data;
	}

	/**
	 * Page On Initialise Event Handler
	 */
	ngOnInit(): void {
		this.changeAccordionHeaderColor("orange")
	}

	/**
	 * show
	 */
	show() {
		this.isLoading = true; // Show the spinner
		this.globalFunctions.displaySpinner(true)
	}

	/**
	 * hide
	 */
	hide() {
		this.isLoading = false; // Hide the spinner after data is loaded
		this.globalFunctions.displaySpinner(false)
	}

	/**
	 * changeAccordionHeaderColor
	 * @param color
	 */
	changeAccordionHeaderColor(color: string) {
		const elements = document.querySelectorAll('.e-accordion .e-acrdn-item.e-select > .e-acrdn-header');
		elements.forEach((element) => {
			(element as HTMLElement).style.background = color;
		});
	}

	/**
	 * Node Selected
	 * @param event
	 */
	public nodeSelected(event: NodeSelectEventArgs) {

		// let data = this.hierarchicalData.find((x: { Id: any; }) => x.Id == event.nodeData.id)
		let queryParams = {}

		if (!this.isParsableAsNumber(event.nodeData['id'])) {
			queryParams = {
				locationID: event.nodeData['id'],
				assetID: undefined
			};

		} else {
			queryParams = {
				locationID: undefined,
				assetID: event.nodeData['id']
			};

		}

		// console.log(event);
		// Update the route with the new query parameters
		this.router.navigate([], {
			relativeTo: this.route,
			queryParams: queryParams,
			queryParamsHandling: 'merge' // merge with existing query parameters
		});
	}

	/**
	 * Check if string can be parsed as int
	 * @param str
	 * @returns
	 */
	isParsableAsNumber(value: any): boolean {
		if (value === null || value === undefined || value === '') {
			return false;
		}

		return Number.isFinite(Number(value));
	}

	/**
	 * onDragStart
	 * @param event 
	 */
	public onDragStart(event: DragAndDropEventArgs) {
		const draggedNodeData = event.draggedNodeData;
		let text: any = draggedNodeData["text"];
		const textParts = text.split(' ', 2);
		if (textParts.length > 1) {
			text = text.substring(text.indexOf(' ') + 1);
		}
		draggedNodeData["text"] = text;
	}

	/**
	 * onDragStop
	 * @param args
	 */
	public async onDragStop(args: DragAndDropEventArgs): Promise<void> {

		if (this.isParsableAsNumber(args.droppedNodeData["id"])) {
			args.cancel = true
		}

		/** if something actually moved */
		if (args.draggedNodeData["id"] != args.droppedNodeData["id"] && 
			args.droppedNodeData["id"] != args.draggedNodeData["parentID"]) { 
			const droppedNodeData = args.droppedNodeData;
			let text: any = droppedNodeData["text"];
			const textParts = text.split(' ', 2);
			if (textParts.length > 1) {
				text = text.substring(text.indexOf(' ') + 1);
			}

			droppedNodeData["text"] = text;
			
			/* if we are trying to move to a location and not asset */
			if (!this.isParsableAsNumber(args.droppedNodeData["id"])) {

				const OKResult = await firstValueFrom(
					this.globalFunctions.UserConfirm$("Move " + args.draggedNodeData["text"] + " to " + args.droppedNodeData["text"] + "?")
				);
				if (OKResult) {
					/** if we dragged an asset (change to use location type) */
					if (this.isParsableAsNumber(args.draggedNodeData["id"])) {

						let asset: any = this.organisationDataService.findObjectByUID(args.draggedNodeData["id"].toString(), this.treeData);
						await this.MoveAsset(this.accountID, this.OrganisationID, asset.AssetID, args.droppedNodeData["id"].toString());

					}
					/** if we dragged a location */
					else {

						let Mylocation: OrganisationsHierarchy = this.organisationDataService.findObjectByUID(args.draggedNodeData["id"].toString(), this.treeData);
						/** changing parent location to where it was dropped */
						Mylocation.ParentUid = args.droppedNodeData["id"].toString();
						await this.PatchLocation(this.accountID, this.OrganisationID, Mylocation)
					}
				}
				else {
					args.cancel = true;
					await this.getOrganisationStructure(this.accountID, this.OrganisationID, this.ShowHiddenLocations);
				}
			}
		}
	}

	/**
	 * MoveAsset
	 * @param accountID 
	 * @param OrganisationID 
	 * @param AssetID 
	 * @param droppedNodeID 
	 */
	async MoveAsset(accountID: string, OrganisationID: string, AssetID: number, droppedNodeID: string) {
		try {
			const response = await firstValueFrom(
				this.assetsDataService.moveOrganisationAssets$(accountID, OrganisationID, AssetID, droppedNodeID)
			);

			if (response) {
				try {
					// console.log("Done")
					await this.getOrganisationStructure(this.accountID, this.OrganisationID, this.ShowHiddenLocations);

					this.globalFunctions.DisplaySnackBar({
						message: "Hierarchy Details Updated",
						type: SnackType.Info,
						duration: 1000
					});
				} catch (error) {
					this.globalFunctions.HandleError(error, "")
				}
			}
		}
		catch (error: any) {
			if (error.status == 404) { }
			else { this.globalFunctions.HandleError(error, "Error: AssetsDataService.moveOrganisationAssets$", false); }
		}

	}

	/**
	 * PatchLocation
	 * @param accountID 
	 * @param OrganisationID 
	 * @param Mylocation 
	 */
	async PatchLocation(accountID: string, OrganisationID: string, Mylocation: IOrganisationsHierarchy) {
		try {
			const response = await firstValueFrom(
				this.organisationDataService.patchOrganisationLocation$(accountID, OrganisationID, Mylocation)
			);

			if (response) {
				try {
					// console.log("Done")
					await this.getOrganisationStructure(this.accountID, this.OrganisationID, this.ShowHiddenLocations)

					this.globalFunctions.DisplaySnackBar({
						message: "Hierarchy Details Updated",
						type: SnackType.Info,
						duration: 1000
					});
				} catch (error) {
					this.globalFunctions.HandleError(error, "")
				}
			}
		}
		catch (error: any) {
			if (error.status == 404) { }
			else { this.globalFunctions.HandleError(error, "Error: AssetsDataService.patchOrganisationLocation$", false); }
		}

	}


	/**
	 * Event triggers once the context menu rendering is completed.
	 */
	onCreated(): void {
		this.content = this.contextMenu.animationSettings.effect = 'SlideDown';
	}

	/**
	 * addDisabled
	 * @param args
	 */
	public addDisabled(args: MenuEventArgs) {
		if (args.item.text === 'Link') {
			args.element.classList.add('e-disabled');
		}
	}

	/**
	 * onNodeClicked
	 * @param args
	 */
	public onNodeClicked(args: NodeClickEventArgs): void {
		if (args.event.button == 2) {
			if (this.contextMenu) { this.contextMenu.open(args.event.clientY, args.event.clientX); }
		}
	}

	/**
	 * Open the custom context menu on right-click
	 * @param args
	 * @param node
	 */
	public onNodeRightClick(args: MouseEvent, node: any): void {
		args.preventDefault();
		// this.treeView.selectedNodes = [node.getAttribute('data-uid')]; // Select the right-clicked node
		if (this.contextMenu) { this.contextMenu.open(args.pageY, args.pageX); }
	}

	/**
	* Get the Organisation Structure
	* @param AccountID AccountID
	* @param OrganisationUID OrganisationUID
	* @param ShowHidden ShowHidden
	*/
	async getOrganisationStructure(AccountID: string, OrganisationUID: string, ShowHidden: number = 0) {

		try {
			const structure = await firstValueFrom(
				this.organisationDataService.getOrganisationStructure$(AccountID, OrganisationUID, ShowHidden)
			);

			if (structure) {
				var OrganisationStructure = <OrganisationsHierarchy[]>JSON.parse(structure);
				this.hierarchicalDataSubject.next(OrganisationStructure);
			}
		}
		catch (error: any) {
			if (error.status == 404) { }
			else { this.globalFunctions.HandleError(error, "Error: this.organisationDataService.getOrganisationStructure$", false); }
		}

	}

	/**
	 * findSelectedLocation
	 * @param locationUID locationUID 
	 */
	findSelectedLocation(locationUID: string) {
		if (this.hierarchicalData) {
			let list = this.flattenSubLocations(this.hierarchicalData);
			let sublocation = list.find((x) => x.Uid == locationUID);
			if (sublocation) {
				this.expandParents(sublocation, list);
			}
			this.router.navigate([this.router.url.split("?")[0]], {});
		}
		else {
			setTimeout(() => {
				this.findSelectedLocation(locationUID);
			}, 1);
		}
	}

	/**
	 * flattenSubLocations
	 * @param hierarchy hierarchy 
	 * @returns 
	 */
	flattenSubLocations(hierarchy: OrganisationsHierarchy[], includeTopLevel: boolean = false): any[] {
		let result: any[] = [];

		// Check if hierarchy is a valid array before proceeding
		if (!Array.isArray(hierarchy)) {
			return result;
		}

		if (includeTopLevel) {
			result.push(...hierarchy);
		}

		// Iterate over each item in the input hierarchy
		for (const item of hierarchy) {
			// Check if the item has a non-empty 'Asset' property
			if (item.SubChild && item.SubChild.length > 0) {
				result = result.concat(item.SubChild);
			}

			// Recursively add all 'Asset' properties of the item's subchildren
			result = result.concat(this.flattenSubLocations(item.SubChild));
		}

		return result;
	}

	/**
	 * expandParents
	 * @param location location  
	 * @param hierarchy hierarchy 
	 */
	expandParents(location: IOrganisationsHierarchy, list: IOrganisationsHierarchy[]) {
		let loop: boolean = true;
		let checkingLocation = location;
		while (loop) {
			let node = this.nodeState.find((x: { node: string; }) => x.node == checkingLocation.Uid);
			if (node) {
				node["expanded"] = true;
			} else {
				this.nodeState.push({ "node": checkingLocation.Uid, "expanded": true });
			}
			if (checkingLocation.ParentUid) {
				let temp = list.find((x: IOrganisationsHierarchy) => x.Uid == checkingLocation.ParentUid);
				if (temp) {
					checkingLocation = temp;
				} else {
					checkingLocation = this.hierarchicalData[0];
				}
			} else {
				loop = false;
				break;
			}
		}
		localStorage.setItem("HeirarchyExpandedNodes", JSON.stringify(this.nodeState));
		this.updateTree();
		// this.subscribeHierarchicalData();
	}

	/**
	 * onDragStop -- dragging onto a dashboard
	 * @param event event  
	 */
	dragIntoDashboard(event: DragAndDropEventArgs) {
		let elements: any[] = [];
		let target: HTMLElement | null = event.target;
		while (target) {
			elements.push(target);
			target = target.parentElement;
		}
		let targetElement: HTMLElement = elements.find((x: HTMLElement) => x.classList.contains("panel-host"));
		const draggedNode: OrganisationsHierarchy | undefined = this.flattenedSubLocations.find((x: OrganisationsHierarchy) => x.Uid == event.draggedNodeData["id"]);
		if (targetElement && draggedNode) {
			this.dragComplete.emit({
				htmlElement: targetElement,
				panelID: targetElement.id,
				draggedNode: draggedNode
			});
		}
	}
}
